<template>
  <div class="ccui-app-container ccui-origin-table">
    <div class="ccui-app-top-bar no-print">
      <div class="title">表格性能测试-原生表格jQuery单行编辑静态页面</div>
      <div class="btn-bar">
        <el-select
          v-model="testPageSize"
          @change="handleChange"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <!-- 表格 -->
    <div class="ccui-multifunctional-table-wrapper">
      <div
        data-v-ab40296c=""
        class="el-table ccui-form-child-table el-table--fit el-table--border el-table--scrollable-x"
      >
        <div class="el-table__body-wrapper is-scrolling-left">
          <table
            cellspacing="0"
            cellpadding="0"
            border="0"
            class="el-table__body"
            style="width: 2986px;"
          >
            <colgroup>
              <col name="el-table_1_column_1" width="48" />
              <col name="el-table_1_column_2" width="48" />
              <col name="el-table_1_column_3" width="110" />
              <col name="el-table_1_column_4" width="300" />
              <col name="el-table_1_column_5" width="130" />
              <col name="el-table_1_column_6" width="130" />
              <col name="el-table_1_column_7" width="90" />
              <col name="el-table_1_column_8" width="130" />
              <col name="el-table_1_column_9" width="130" />
              <col name="el-table_1_column_10" width="130" />
              <col name="el-table_1_column_11" width="130" />
              <col name="el-table_1_column_12" width="130" />
              <col name="el-table_1_column_13" width="130" />
              <col name="el-table_1_column_14" width="200" />
              <col name="el-table_1_column_15" width="170" />
              <col name="el-table_1_column_16" width="200" />
              <col name="el-table_1_column_17" width="130" />
              <col name="el-table_1_column_18" width="130" />
              <col name="el-table_1_column_19" width="130" />
              <col name="el-table_1_column_20" width="130" />
              <col name="el-table_1_column_21" width="130" />
              <col name="el-table_1_column_22" width="130" />
            </colgroup>
            <thead class="has-gutter">
              <tr class="">
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_1  is-center el-table-column--selection   is-leaf"
                >
                  <div class="cell">
                    <label role="checkbox" class="el-checkbox"
                      ><span aria-checked="mixed" class="el-checkbox__input"
                        ><span class="el-checkbox__inner"></span
                        ><input
                          type="checkbox"
                          aria-hidden="true"
                          class="el-checkbox__original"
                          value=""
                      /></span>

                      <!----></label
                    >
                  </div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_2  is-center is-leaf"
                >
                  <div class="cell">序号</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_3   is-leaf"
                >
                  <div class="cell">设备物资编码</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_4   is-leaf"
                >
                  <div class="cell">设备物资名称</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_5     is-leaf"
                >
                  <div class="cell">设备物资说明</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_6     is-leaf"
                >
                  <div class="cell">分类名称</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_7     is-leaf"
                >
                  <div class="cell">计量单位</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_8     is-leaf"
                >
                  <div class="cell">数量</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_9     is-leaf"
                >
                  <div class="cell">不含税单价</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_10     is-leaf"
                >
                  <div class="cell">不含税金额</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_11     is-leaf"
                >
                  <div class="cell">含税单价</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_12     is-leaf"
                >
                  <div class="cell">含税金额</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_13     is-leaf"
                >
                  <div class="cell">税额</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_14     is-leaf"
                >
                  <div class="cell">交货地点</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_15     is-leaf"
                >
                  <div class="cell">交货时间</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_16     is-leaf"
                >
                  <div class="cell">生产厂家/品牌</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_17     is-leaf"
                >
                  <div class="cell">采购计划编号</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_18     is-leaf"
                >
                  <div class="cell">采购计划名称</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_19     is-leaf"
                >
                  <div class="cell">方案编号</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_20     is-leaf"
                >
                  <div class="cell">方案名称</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_21     is-leaf"
                >
                  <div class="cell">协议编号</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_1_column_22     is-leaf"
                >
                  <div class="cell">协议名称</div>
                </th>
                <th class="gutter" style="width: 0px; display: none;"></th>
              </tr>
            </thead>
            <tbody id="ccui-jquery-table">
              <!---->
            </tbody>
          </table>
          <!---->
        </div>
        <!---->
      </div>
      <!----><!---->
    </div>
    <!-- 表格 end -->
  </div>
</template>

<script>
require("core-js/modules/es.object.assign");
require("core-js/modules/es.object.keys");
require("regenerator-runtime/runtime");
require("core-js/modules/es.object.values");
require("core-js/modules/es.object.set-prototype-of");
require("core-js/modules/es.array.find");
require("core-js/modules/es.array-buffer.is-view");
require("core-js/modules/es.weak-map");
require("core-js/modules/es.promise");
const ExcelJS = require("exceljs");
const uuid = require("uuid");
import { saveAs } from "file-saver";
const $ = require("jquery");
// import draggable from "vuedraggable";
import { removeDemoUser, getListbycheck } from "../api/item-list";
import {
  setSessionItem,
  getSessionItem,
  // removeSessionItem,
  // ishasAgentId,
  formatNumber
} from "@/basa/utils";
export default {
  components: {
    // draggable
  },
  name: "listquery-origin-table-input-jquery-list",
  data() {
    return {
      tableStr: "",
      testPageSize: 20,
      options: [
        {
          value: 10,
          label: "10页"
        },
        {
          value: 20,
          label: "20页"
        },
        {
          value: 50,
          label: "50页"
        },
        {
          value: 100,
          label: "100页"
        },
        {
          value: 200,
          label: "200页"
        },
        {
          value: 300,
          label: "300页"
        },
        {
          value: 500,
          label: "500页"
        },
        {
          value: 600,
          label: "600页"
        },
        {
          value: 700,
          label: "700页"
        },
        {
          value: 800,
          label: "800页"
        },
        {
          value: 900,
          label: "900页"
        },
        {
          value: 1000,
          label: "1000页"
        }
      ],
      getSpecificationsArr: ["1305", "1306", "1307", "1308", "1309", "990103"],
      tableList: [],
      tableListSeed: {
        smpBrandRelationReqBOS: [],
        loginId: "",
        taxRatePercent: "3%",
        groupId: 100001,
        county: "140101",
        currentSettledNum: null,
        planName: "",
        currentChangeAmtExcludeTax: 0,
        matDescribe: "",
        currentUnitPriceIncludeTax: null,
        specifications: "普通热轧带肋钢筋",
        baseProportion: 1,
        firstId: 49524,
        quantityDelivered: null,
        currentSettlementNum: null,
        acceptanceQuantity: null,
        province: "140000",
        currentMeasuringUnitCode: "01",
        currentChangeAmtIncludeTax: 0,
        appId: 100116,
        currentUnitPriceExcludeTax: null,
        isNewest: 1,
        planId: "",
        id: 49524,
        partyId: null,
        firstCategoriesOfCode: "01",
        deliveryPoints: "qw3eqwe",
        baseChangeAmtExcludeTax: null,
        concId: 9391,
        protocalName: "",
        appToken: "",
        deptId: null,
        deliveryAreaCode: "910000",
        pkPurmatdetl: "",
        taxRate: 0.03,
        matResource: "3",
        specificationsCode: "01010110001",
        baseAmtIncludeTax: null,
        baseSettledNum: null,
        isEnabled: 0,
        minPrice: null,
        pkPackinfo: "",
        maxPrice: null,
        protocalId: "",
        provinceName: "山西省",
        materialsCode: "00000000001",
        taxRateCode: "10",
        agentId: "100003@100116",
        deliveryTime: "2021-07-17",
        city: "140100",
        thirdCategoriesOfName: "热轧带肋钢筋",
        openId: null,
        deliveryAreaName: "华北",
        versionIds: "49524-",
        currentMeasuringUnit: "吨-修改",
        partyRelaId: null,
        orgId: 100003,
        baseUnitPriceExcludeTax: null,
        manufacturer: "",
        cityName: "太原市",
        isChangeFlag: null,
        storageQuantity: null,
        rate: 0,
        currentProportion: 1,
        baseNum: "0.00000000",
        contractPerson: "",
        currentNum: null,
        sn: 1,
        purchasePlanCode: "",
        thirdCategoriesOfCode: "010101",
        materialsName: "普通热轧带肋钢筋 HRB335 6mm",
        protocalCode: "",
        baseMeasuringUnitCode: "01",
        countyName: "市辖区",
        purchasePlanId: "",
        packname: "",
        purchasePlanName: "",
        mobile: "",
        priceType: "",
        baseMeasuringUnit: "吨-修改",
        userId: "",
        bizVersion: 1,
        planCode: "",
        contractPersonTel: "",
        personName: "",
        userToken: "",
        baseUnitPriceIncludeTax: null,
        firstCategoriesOfName: "钢材",
        lastestPid: 49524,
        baseSettlementNum: null,
        manufacturerDisabled: true,
        onlyId: "ac9202d1-452d-4d92-a23a-e7fe6a391c42",
        address: "华北山西省太原市市辖区qw3eqwe"
      },
      getMultiRateCode: false,
      tabledatas: [
        { tab1: "111", tab2: "2222", show: true },
        { tab1: "aaa", tab2: "bbb", show: false }
      ],
      isShowDetail: true,
      isShowEdit: true,
      multiDataToEnd: {},
      singleDataToEnd: {},
      // 表格相关
      tableData: [], // 表格数据
      draggFlag: true,
      tableName: this.tableList.listqueryList, // 表格命名
      tableThead: [], // 表格数据
      // 锁定表格
      fixedTableThead: [
        {
          label: "序号",
          prop: "id",
          width: "38",
          checked: true,
          fixed: true,
          type: "index",
          resizable: false
        }
      ],
      // 非锁定表格
      unfixedTableThead: [
        {
          label: "姓名",
          prop: "userName",
          width: "62",
          checked: true
        },
        {
          label: "性别",
          prop: "sex",
          width: "60",
          checked: true,
          formatterName: "sexHandler"
        },
        {
          label: "出生日期",
          prop: "birthday",
          width: "120",
          checked: true
        },
        {
          label: "政治面貌",
          prop: "politicalOutlook",
          width: "80",
          checked: true,
          formatterName: "outlookHandler"
        },
        {
          label: "工龄",
          prop: "workYears",
          width: "60",
          checked: true
        },
        {
          label: "婚姻状况",
          prop: "isMarried",
          width: "72",
          checked: true,
          formatterName: "ismarriedHandler"
        },
        {
          label: "年收入",
          prop: "annualIncome",
          width: "80",
          checked: true,
          align: "right",
          headerAlign: "left"
        },
        {
          label: "身份证号",
          prop: "idNum",
          width: "142",
          checked: true,
          formatterName: "idNumHandle"
        },
        {
          label: "手机号",
          prop: "userMobile",
          width: "120",
          checked: true,
          formatterName: "userMobileHandle"
        },
        {
          label: "备注",
          prop: "remarks",
          width: "300",
          checked: true
        }
      ],
      // 动态表格
      tableTheadOptions: [],
      // 弹框表格
      // popoverShow: false,
      selectRow: [],
      selectData: [],
      isFocus: 1,

      // 表格相关 end
      // 高级搜索数据 start
      formData: {
        userName: "",
        sex: "",
        birthday: "",
        politicalOutlook: "",
        isMarried: ""
      }, // 高级搜索提交数据
      formDataSearch: "",
      localSearchData: {},
      politicalOutlookOptions: [
        {
          label: "群众",
          value: "1"
        },
        {
          label: "团员",
          value: "2"
        },
        {
          label: "党员",
          value: "3"
        }
      ],
      isShowSearch: true,
      isShow: false,
      // 高级搜索数据 end
      isShowPagination: false, //无数据的不展示底部全选，批量删除
      // 全选以及页码
      totalNum: 0,
      total: 0,
      isIndeterminate: false,
      checkAll: false,
      value: "",
      pageNoCode: this.getLocalPageNo(),
      pageSizeCode: this.getLocalPageSize(),
      // isFist: false,
      // 全选以及页码 end
      // 表格数据删除相关
      delDemoId: "",
      content: "您确定要删除吗？",
      typeDel: "", //有关批量删除
      isSelection: false,
      // 表格数据删除相关 end
      // 排序入参所需字段
      sortord: "",
      sortprop: "",
      // 表格数据相关处理
      formatterList: {
        sexHandler(row, col) {
          switch (row.sex) {
            case 1:
              return "男";
            case 2:
              return "女";
          }
        },
        outlookHandler(row, col) {
          switch (row.politicalOutlook) {
            case 1:
              return "群众";
            case 2:
              return "团员";
            case 3:
              return "党员";
          }
        },
        ismarriedHandler(row, col) {
          switch (row.isMarried) {
            case 0:
              return "未婚";
            case 1:
              return "已婚";
          }
        },
        userMobileHandle(row) {
          var reg = /(\d{3})\d{4}(\d{4})/;
          return row.userMobile
            ? (row.userMobile = row.userMobile.replace(reg, "$1****$2"))
            : (row.userMobile = "");
        },
        idNumHandle(row) {
          var reg = /(\d{6})(\d+)(\d{3}[0-9xX])/;
          return row.idNum
            ? (row.idNum = row.idNum.replace(reg, "$1********$3"))
            : (row.idNum = "");
        },
        isCreated: false
      }
      // 表格数据相关处理 end
    };
  },
  created() {
    this.init();
  },
  mounted() {
    // this.setInitData();
    $("#ccui-jquery-table").html(this.tableStr);
  },
  watch: {},
  methods: {
    init() {
      this.testPageSize = localStorage.getItem("testPageSize") || 20;
      let n = this.testPageSize;
      const arr = [];
      for (let j = 0; j < n; j++) {
        this.tableListSeed.materialsCode = uuid.v4();
        this.tableListSeed.index = j;
        arr.push(JSON.parse(JSON.stringify(this.tableListSeed)));
      }
      // this.tableList = arr;
      let len = arr.length;
      let str = `<tr class="el-table__row" :key="key">
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_1_column_1 is-center el-table-column--selection"
                  >
                    <div class="cell">
                      <label role="checkbox" class="el-checkbox"
                        ><span aria-checked="mixed" class="el-checkbox__input"
                          ><span class="el-checkbox__inner"></span
                          ><input
                            type="checkbox"
                            aria-hidden="true"
                            class="el-checkbox__original"
                            value=""
                        /></span>

                        <!----></label
                      >
                    </div>
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_1_column_2 is-center"
                  >
                    <div class="cell el-tooltip">
                      <div>1</div>
                    </div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_3">
                    <div class="cell el-tooltip" style="width: 108px;">
                      {{ item.materialsCode }}
                    </div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_4">
                    <div class="cell el-tooltip" style="width: 298px;">
                      普通热轧带肋钢筋 HRB335 6mm
                    </div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_5  ">
                    <div class="cell el-tooltip" style="width: 128px;">
                      <input
                        data-v-ab40296c=""
                        type="text"
                        class="el-input__inner"
                      />
                    </div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_6  ">
                    <div class="cell el-tooltip" style="width: 128px;">
                      热轧带肋钢筋
                    </div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_7  ">
                    <div class="cell el-tooltip" style="width: 88px;">
                      吨-修改
                    </div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_8  ">
                    <div class="cell">
                      <input
                        data-v-ab40296c=""
                        type="text"
                        class="el-input__inner"
                      />
                    </div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_9  ">
                    <div class="cell el-tooltip" style="width: 128px;">
                      <span data-v-ab40296c=""></span>
                    </div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_10  ">
                    <div class="cell el-tooltip" style="width: 128px;">
                      <span data-v-ab40296c="">0</span>
                    </div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_11  ">
                    <div class="cell">
                      <input
                        data-v-ab40296c=""
                        type="text"
                        class="el-input__inner"
                      />
                    </div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_12  ">
                    <div class="cell el-tooltip" style="width: 128px;">
                      <span data-v-ab40296c="">0.00</span>
                    </div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_13  ">
                    <div class="cell el-tooltip" style="width: 128px;">
                      row.rate0 <span data-v-ab40296c=""></span>
                    </div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_14  ">
                    <div class="cell el-tooltip" style="width: 198px;">
                      <span data-v-ab40296c=""
                        >华北山西省太原市市辖区qw3eqwe</span
                      >
                    </div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_15  ">
                    <div class="cell">
                      <div
                        data-v-ab40296c=""
                        class="el-date-editor el-input el-input--suffix el-date-editor--date"
                      >
                        <!----><input
                          placeholder="选择日期"
                          type="text"
                          autocomplete="off"
                          name=""
                          class="el-input__inner"
                        /><!----><span class="el-input__suffix"
                          ><span class="el-input__suffix-inner"
                            ><i class="el-input__icon"></i
                            ><i class="el-input__icon el-icon-date"></i
                            ><!----><!----><!----><!----><!----></span
                          >
                          <!----></span
                        ><!----><!---->
                      </div>
                    </div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_16  ">
                    <div class="cell">
                      <div
                        data-v-ab40296c=""
                        class="el-input is-disabled el-input-group el-input-group--append"
                      >
                        <!----><input
                          placeholder="请输入生产厂家/品牌"
                          type="text"
                          disabled="disabled"
                          autocomplete="off"
                          class="el-input__inner"
                        /><!----><!---->
                        <div class="el-input-group__append">
                          <button
                            data-v-ab40296c=""
                            type="button"
                            class="el-button el-button--default"
                          >
                            <!---->
                            <!----><span>选择</span>
                          </button>
                        </div>
                        <!---->
                      </div>
                    </div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_17  ">
                    <div class="cell el-tooltip" style="width: 128px;"></div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_18  ">
                    <div class="cell el-tooltip" style="width: 128px;"></div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_19  ">
                    <div class="cell el-tooltip" style="width: 128px;"></div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_20  ">
                    <div class="cell el-tooltip" style="width: 128px;"></div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_21  ">
                    <div class="cell el-tooltip" style="width: 128px;"></div>
                  </td>
                  <td rowspan="1" colspan="1" class="el-table_1_column_22  ">
                    <div class="cell el-tooltip" style="width: 128px;"></div>
                  </td>
                </tr>`;
      for (let i = 0; i < len; i++) {
        str += `<tr class="el-table__row" :key="key">
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_1_column_1 is-center el-table-column--selection"
                  >
                    <div class="cell">
                      <label role="checkbox" class="el-checkbox"
                        ><span aria-checked="mixed" class="el-checkbox__input"
                          ><span class="el-checkbox__inner"></span
                          ><input
                            type="checkbox"
                            aria-hidden="true"
                            class="el-checkbox__original"
                            value=""
                        /></span>

                        <!----></label
        >
        </div>
        </td>
        <td
        rowspan="1"
        colspan="1"
        class="el-table_1_column_2 is-center"
        >
        <div class="cell el-tooltip">
        <div>1</div>
        </div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_3">
        <div class="cell el-tooltip" style="width: 108px;">
        ${arr[i].materialsCode}
        </div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_4">
        <div class="cell el-tooltip" style="width: 298px;">
        普通热轧带肋钢筋 HRB335 6mm
        </div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_5  ">
        <div class="cell el-tooltip" style="width: 128px;">

        </div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_6  ">
        <div class="cell el-tooltip" style="width: 128px;">
        热轧带肋钢筋
        </div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_7  ">
        <div class="cell el-tooltip" style="width: 88px;">
        吨-修改
        </div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_8  ">
        <div class="cell">

        </div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_9  ">
        <div class="cell el-tooltip" style="width: 128px;">
        <span data-v-ab40296c=""></span>
        </div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_10  ">
        <div class="cell el-tooltip" style="width: 128px;">
        <span data-v-ab40296c="">0</span>
        </div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_11  ">
        <div class="cell">

        </div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_12  ">
        <div class="cell el-tooltip" style="width: 128px;">
        <span data-v-ab40296c="">0.00</span>
        </div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_13  ">
        <div class="cell el-tooltip" style="width: 128px;">
        row.rate0 <span data-v-ab40296c=""></span>
        </div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_14  ">
        <div class="cell el-tooltip" style="width: 198px;">
        <span data-v-ab40296c=""
        >华北山西省太原市市辖区qw3eqwe</span
        >
        </div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_15  ">
        <div class="cell">
        <div
        data-v-ab40296c=""
        class="el-date-editor el-input el-input--suffix el-date-editor--date"
        >
            <!----><!----><span class="el-input__suffix"
        ><span class="el-input__suffix-inner"
        ><i class="el-input__icon"></i
        ><i class="el-input__icon el-icon-date"></i
        ><!----><!----><!----><!----><!----></span
        >
            <!----></span
        ><!----><!---->
        </div>
        </div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_16  ">
        <div class="cell">

        </div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_17  ">
        <div class="cell el-tooltip" style="width: 128px;"></div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_18  ">
        <div class="cell el-tooltip" style="width: 128px;"></div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_19  ">
        <div class="cell el-tooltip" style="width: 128px;"></div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_20  ">
        <div class="cell el-tooltip" style="width: 128px;"></div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_21  ">
        <div class="cell el-tooltip" style="width: 128px;"></div>
        </td>
        <td rowspan="1" colspan="1" class="el-table_1_column_22  ">
        <div class="cell el-tooltip" style="width: 128px;"></div>
        </td>
        </tr>`;
      }
      // console.log(str)
      this.tableStr = str;
    },
    handleChange(val) {
      console.log(val);
      localStorage.setItem("testPageSize", val);
      const s = location.href;
      location.href = s;
    },
    // 校验单价是否合法
    handleBlur($event, row, val) {
      if (row.priceType && [1, 2].includes(row.priceType)) {
        if (row[val] > row.maxprice) {
          row[val] = row.maxprice;
        }
      }
      if (row.priceType && row.priceType === 2) {
        if (row[val] < row.minprice) {
          row[val] = row.minprice;
        }
      }

      this.testColumn($event, row, "blur", "currentUnitPriceIncludeTax");
    },
    testColumn(e, row, eventType, nameModel) {
      switch (eventType) {
        case "blur":
          if (e !== null) {
            e.target.style.border = `1px solid ${
              row[nameModel] ? "#ccc" : "red"
            }`;
          }

          // 截取小数后位数
          if (
            this.getInputRule(row[nameModel]) &&
            [
              "currentNum",
              "currentUnitPriceIncludeTax",
              "currentChangeAmtIncludeTax"
            ].includes(nameModel)
          ) {
            row[nameModel] = formatNumber(
              Number(row[nameModel]),
              nameModel === "currentNum" ? 3 : 2
            );
          }

          // 计算 start
          // if (
          //   row.currentNum &&
          //   row.currentUnitPriceIncludeTax &&
          //   this.getInputRule(row.currentNum) &&
          //   this.getInputRule(row.currentUnitPriceIncludeTax)
          // ) {
          //   const newTaxRate = new this.$BigNumber(this.taxRateParams).plus(1);
          //   // 合同金额
          //   const price = new this.$BigNumber(row.currentNum).multipliedBy(
          //     row.currentUnitPriceIncludeTax
          //   );
          //   // 计算含税金额(含税)(单行)
          //   row.currentChangeAmtIncludeTax = this.setToFixed(price, 2);

          //   if (!this.getMultiRateCode) {
          //     console.log(1111);
          //     const amtExcludeTax = new this.$BigNumber(price).dividedBy(
          //       newTaxRate
          //     );
          //     // 计算不含税单价
          //     row.currentUnitPriceExcludeTax = this.setToFixed(
          //       new this.$BigNumber(row.currentUnitPriceIncludeTax).dividedBy(
          //         newTaxRate
          //       ),
          //       2
          //     );
          //     // 计算不含税金额
          //     row.currentChangeAmtExcludeTax = this.setToFixed(
          //       amtExcludeTax,
          //       2
          //     );
          //     // 计算税额
          //     row.rate = this.setToFixed(
          //       new this.$BigNumber(price).minus(amtExcludeTax),
          //       2
          //     );
          //     console.log(
          //       "计算后的值==>>",
          //       row.currentUnitPriceExcludeTax,
          //       row.currentChangeAmtExcludeTax,
          //       row.rate
          //     );
          //     console.log(this.purchaseList, "this.purchaseList");
          //     this.purchaseList.splice();
          //   } else {
          //     console.log(2222);
          //     if (row.taxRatePercent != "免税" && row.taxRatePercent) {
          //       const val = row.taxRatePercent.substring(
          //         0,
          //         row.taxRatePercent.indexOf("%")
          //       );
          //       row.taxRate = Number(val) / 100;
          //     } else {
          //       row.taxRate = 0;
          //     }
          //     const newTaxRate = new this.$BigNumber(row.taxRate).plus(1);
          //     const amtExcludeTax = new this.$BigNumber(price).dividedBy(
          //       newTaxRate
          //     );
          //     // 计算不含税金额
          //     row.currentChangeAmtExcludeTax = this.setToFixed(
          //       amtExcludeTax,
          //       2
          //     );
          //     // 计算不含税单价
          //     row.currentUnitPriceExcludeTax = this.setToFixed(
          //       new this.$BigNumber(row.currentUnitPriceIncludeTax).dividedBy(
          //         newTaxRate
          //       ),
          //       2
          //     );
          //     // 计算税额
          //     row.rate = this.setToFixed(
          //       new this.$BigNumber(price).minus(amtExcludeTax),
          //       2
          //     );
          //   }
          // } else {
          //   // row.currentChangeAmtIncludeTax = "";
          //   // row.currentChangeAmtExcludeTax = "";
          //   // row.currentUnitPriceExcludeTax = "";
          //   // row.rate = "";
          // }

          // // 特殊 code 值的计算
          // if (
          //   this.getInputRule(row.currentChangeAmtIncludeTax) &&
          //   this.isCurrentTaxShow(row)
          // ) {
          //   if (!this.getMultiRateCode) {
          //     // 1 + 税率
          //     const newTaxRate = new this.$BigNumber(this.taxRateParams).plus(
          //       1
          //     );
          //     // 不含税金额
          //     const amountExcludingTax = new this.$BigNumber(
          //       row.currentChangeAmtIncludeTax
          //     ).dividedBy(newTaxRate);
          //     // 计算不含税金额
          //     row.currentChangeAmtExcludeTax = this.setToFixed(
          //       amountExcludingTax,
          //       2
          //     );

          //     // 计算税额
          //     row.rate = this.setToFixed(
          //       new this.$BigNumber(row.currentChangeAmtIncludeTax).minus(
          //         amountExcludingTax
          //       ),
          //       2
          //     );
          //   } else {
          //     // 截取税率
          //     if (row.taxRatePercent != "免税" && row.taxRatePercent) {
          //       const val = row.taxRatePercent.substring(
          //         0,
          //         row.taxRatePercent.indexOf("%")
          //       );
          //       row.taxRate = Number(val) / 100;
          //     } else {
          //       row.taxRate = 0;
          //     }
          //     // 1 + 税率
          //     const newTaxRate = new this.$BigNumber(row.taxRate).plus(1);
          //     // 不含税金额
          //     const amountExcludingTax = new this.$BigNumber(
          //       row.currentChangeAmtIncludeTax
          //     ).dividedBy(newTaxRate);
          //     // 计算不含税金额
          //     row.currentChangeAmtExcludeTax = this.setToFixed(
          //       amountExcludingTax,
          //       2
          //     );
          //     // 计算税额
          //     row.rate = this.setToFixed(
          //       new this.$BigNumber(row.currentChangeAmtIncludeTax).minus(
          //         amountExcludingTax
          //       ),
          //       2
          //     );
          //   }
          // } else {
          //   row.currentChangeAmtExcludeTax = "";
          //   row.rate = "";
          // }

          // const isIncludesTax = this.purchaseList.every(
          //   _ => _.currentChangeAmtIncludeTax
          // );
          // const isExcludesTax = this.purchaseList.every(
          //   _ => _.currentChangeAmtExcludeTax
          // );
          // if (isIncludesTax && isExcludesTax) {
          //   // 计算合同金额(含税)(基础信息总和)
          //   const setContractPriceIncludeTax = this.setToFixed(
          //     this.purchaseList.reduce(
          //       (pre, cur) =>
          //         new this.$BigNumber(pre).plus(
          //           Number(cur.currentChangeAmtIncludeTax)
          //         ),
          //       0
          //     ),
          //     2
          //   );
          //   // 计算合同金额(不含税)(基础信息总和)
          //   const setContractPriceExcludeTax = this.setToFixed(
          //     this.purchaseList.reduce(
          //       (pre, cur) =>
          //         new this.$BigNumber(pre).plus(
          //           Number(cur.currentChangeAmtExcludeTax)
          //         ),
          //       0
          //     ),
          //     2
          //   );
          //   this.$bus.$emit("setPriceSum", {
          //     setContractPriceIncludeTax,
          //     setContractPriceExcludeTax
          //   });
          // }

          // 计算 end
          break;
        case "focus":
          if (e !== null) {
            e.target.style.border = "1px solid #0089EF";
          }
          break;
        default:
          break;
      }
    },
    isCurrentTaxShow(row) {
      return row.specificationsCode
        ? this.getSpecificationsArr.some(item =>
            row.specificationsCode.startsWith(item)
          )
        : false;
    },
    isCurrentNunShow(row) {
      return row.specificationsCode
        ? !this.getSpecificationsArr.some(item =>
            row.specificationsCode.startsWith(item)
          )
        : true;
    },
    getInputRule(val) {
      const reg = /^\d*\.?\d*$/;
      return reg.test(val);
    },

    // end
    setInitData() {
      this.isShow = false;
      // this.getUserList();
      this.setTableWidth();
      this.renderTable();
      // this.isFist = false;
    },
    // 导出
    async handleExport(type) {
      let sexObj = {
        1: "男",
        2: "女"
      };
      let politicalOutlookobj = {
        1: "群众",
        2: "团员",
        3: "党员"
      };
      let isMarriedobj = {
        0: "未婚",
        1: "已婚"
      };
      const wb = new ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("第一页");
      const page1Row1 = ws1.addRow([
        "序号",
        "姓名",
        "性别",
        "出生日期",
        "政治面貌",
        "工龄",
        "婚姻状况",
        "年收入",
        "身份证号",
        "手机号",
        "备注"
      ]);
      if (type === "all") {
        let res = await getListbycheck({
          pageNo: 1,
          userName: "",
          pageSize: 5000,
          sortprop: "",
          sortord: "",
          isDelete: 0
        });
        if (res.data.data.rows.length > 0) {
          res.data.data.rows.forEach((item, index) => {
            ws1.addRow([
              index + 1,
              item.userName,
              sexObj[item.sex],
              item.birthday ? item.birthday.substr(0, 10) : "",
              politicalOutlookobj[item.politicalOutlook],
              item.workYears,
              isMarriedobj[item.isMarried],
              type === "all"
                ? item.annualIncome
                  ? "￥" + item.annualIncome.toFixed(2)
                  : ""
                : item.annualIncome,
              item.idNum
                ? item.idNum.replace(
                    /(\d{6})(\d+)(\d{3}[0-9xX])/,
                    "$1********$3"
                  )
                : "",
              item.userMobile
                ? item.userMobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
                : "",
              item.remarks
            ]);
          });
        }
      } else {
        this.tableData.forEach((item, index) => {
          ws1.addRow([
            index + 1,
            item.userName,
            sexObj[item.sex],
            item.birthday ? item.birthday.substr(0, 10) : "",
            politicalOutlookobj[item.politicalOutlook],
            item.workYears,
            isMarriedobj[item.isMarried],
            type === "all"
              ? item.annualIncome
                ? "￥" + item.annualIncome.toFixed(2)
                : ""
              : item.annualIncome,
            item.idNum
              ? item.idNum.replace(/(\d{6})(\d+)(\d{3}[0-9xX])/, "$1********$3")
              : "",
            item.userMobile
              ? item.userMobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
              : "",
            item.remarks
          ]);
        });
      }
      ws1.columns = [
        { key: "id", width: 5 },
        { key: "userName", width: 10 },
        { key: "sex", width: 8 },
        { key: "birthday", width: 20 },
        { key: "politicalOutlook", width: 10 },
        { key: "workYears", width: 10 },
        { key: "isMarried", width: 10 },
        { key: "annualIncome", width: 15 },
        { key: "idNum", width: 20 },
        { key: "userMobile", width: 20 },
        { key: "remarks", width: 70 }
      ];
      page1Row1.font = { bold: true, color: { argb: "00489A" } };
      page1Row1.fill = { color: { argb: "000000" } };
      const buf = await wb.xlsx.writeBuffer();
      saveAs(new Blob([buf]), "增删改查.xlsx");
    },
    // 根据返回状态显示不同的文字颜色
    // eslint-disable-next-line no-unused-vars
    setStyle({ row, column, rowIndex, columnIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { "background-color": "transparent" };
      }
    },
    // 默认渲染表格
    renderTable() {
      const localTableData = localStorage.getItem(this.tableName)
        ? JSON.parse(localStorage.getItem(this.tableName))
        : [];
      let unfixedTableThead = this.unfixedTableThead.concat(
        this.fixedTableThead
      );
      let localTableDataStr = localTableData.map(
        ({ label, prop, formatter, align }) =>
          JSON.stringify({ label, prop, formatter, align })
      );
      let unfixedTableTheadStr = unfixedTableThead.map(
        ({ label, prop, formatter, align }) =>
          JSON.stringify({ label, prop, formatter, align })
      );

      if (localTableData.length === unfixedTableThead.length) {
        let flag = localTableDataStr.every(item =>
          unfixedTableTheadStr.includes(item)
        );
        if (flag) {
          // 完全相同
          this.tableTheadOptions = localTableData;
          this.tableThead = localTableData;
          this.unfixedTableThead = localTableData.filter(item => {
            return !this.fixedTableThead.find(
              cItem => item.prop === cItem.prop
            );
          });
        } else {
          // 长度相同但值不同
          this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
          const comment = JSON.stringify(this.tableThead);
          localStorage.setItem(this.tableName, comment);
          const localTableData = JSON.parse(
            localStorage.getItem(this.tableName)
          );
          this.tableTheadOptions = localTableData;
        }
      } else {
        // 长度不同
        this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
        const comment = JSON.stringify(this.tableThead);
        localStorage.setItem(this.tableName, comment);
        const localTableData = JSON.parse(localStorage.getItem(this.tableName));
        this.tableTheadOptions = localTableData;
      }
    },
    // 表格弹框拖拽触发
    handleTableChange(val) {
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      this.tableTheadOptions = localTableData;
    },
    // 是否显示对应列
    handleUpdate(item, index) {
      for (let i = 0; i < this.unfixedTableThead.length; i++) {
        if (i === index) {
          this.unfixedTableThead.checked = !this.unfixedTableThead.checked;
        }
      }
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      this.tableTheadOptions = localTableData;
    },
    // 渲染本地存储表格宽度
    setTableWidth() {
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      if (localTableData) {
        for (let i = 0; i < this.tableTheadOptions.length; i++) {
          if (this.tableTheadOptions[i].label === localTableData[i].label) {
            this.tableTheadOptions[i].width = localTableData[i].width;
          }
        }
      }
    },
    // 表格宽度更改存入
    setTableTitleWidth(newWidth, oldWidth, column, event) {
      for (let i = 0; i < this.unfixedTableThead.length; i++) {
        if (this.unfixedTableThead[i].label === column.label) {
          this.unfixedTableThead[i].width = newWidth;
        }
      }
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      this.tableTheadOptions = JSON.parse(localStorage.getItem(this.tableName));
      this.draggFlag = false;
      this.$nextTick(() => {
        this.draggFlag = true;
      });
    },
    handleSelectionChange(data) {
      this.selectData = data;
    },
    setRowclass({ row, rowIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { "background-color": "rgba(255,232,195,1) " };
      }
    },
    // 跳转编辑页
    jumpEdit(index, row) {
      this.$router.push("/list-query/singleTab/edit-item/" + row.id);
    },
    // 跳转详情页
    jumpDetail(index, row) {
      this.$router.push(`/list-query/singleTab/item-detail/${row.id}/${index}`);
    },
    // 跳转新增页
    jumpNew() {
      this.$router.push("/list-query/singleTab/new-item");
    },
    // 删除列表数据
    handleDelete(index, row) {
      this.deleteLog();
      this.delDemoId = row.id;
    },
    // 删除弹框
    deleteLog() {
      this.$confirm("您确定要删除吗？", "删除确认", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      })
        .then(() => {
          if (this.typeDel == "all") {
            this.delPeople(this.idArrSelected);
          } else {
            this.delPeople([this.delDemoId]);
          }
        })
        .catch(() => {
          console.log("取消删除");
        });
    },
    // 批量删除并刷新列表
    handleDelSelected() {
      if (this.idArrSelected) {
        this.typeDel = "all";
        this.deleteLog();
      } else {
        this.$message({
          message: "请选择您要删除的数据",
          type: "warning"
        });
      }
    },
    // 上一页
    handlePrev() {
      console.log("上一页");
    },
    // 下一页
    handleNext() {
      console.log("下一页");
    },
    // 每页条数发生改变
    handleSizeChange(val) {
      this.pageNoCode = 1;
      if (val !== "none") {
        this.pageSizeCode = val;
        setSessionItem("pageSize", this.tableName, val);
      }
      this.getUserList(this.formDataSearch);
    },
    // 当前页发生改变
    handleCurrentChange(val) {
      let searchFormData = getSessionItem("pageNo", this.tableName) || {};
      setSessionItem("pageNo", this.tableName, {
        pageNo: val,
        searchForm: searchFormData.searchForm || {}
      });
      this.formDataSearch = {
        ...this.formDataSearch,
        ...searchFormData.searchForm
      };
      // 跳转翻页都会调这个方法
      this.pageNoCode = val;
      this.getUserList(this.formDataSearch);
    },
    // 高级搜索所需函数 start
    // 高级搜索展开按钮
    searchItem(searchData) {
      this.pageNoCode = 1;
      this.formDataSearch = searchData;
      this.localSearchData = JSON.parse(JSON.stringify(searchData));
      setSessionItem("pageNo", this.tableName, {
        pageNo: this.pageNoCode,
        searchForm: this.localSearchData
      });
      console.log(this.formDataSearch.birthday);
      this.getUserList(this.formDataSearch);
    },
    // 高级搜索 end
    // 列表数据请求
    getUserList(reqObj) {
      console.log(this.pageNoCode);
      let obj = {};
      obj = typeof reqObj == "object" ? reqObj : obj;
      obj.pageNo = this.pageNoCode;
      obj.business = "";
      obj.pageSize = this.pageSizeCode;
      obj.isDelete = 0;
      obj.isShowPageLoading = true;
      getListbycheck(obj)
        .then(res => {
          console.log(res);
          this.isShowPagination = res.data.data.recordsTotal > 0;
          this.tableData = res.data.data.rows;
          this.totalNum = res.data.data.recordsTotal;
          this.total = res.data.data.total;
          this.pageNoCode = res.data.data.pageNo; // 当前页
          this.tableData.forEach((i, index) => {
            i.annualIncome = i.annualIncome
              ? "￥" + i.annualIncome.toFixed(2)
              : "";
            i.birthday = i.birthday ? i.birthday.substr(0, 10) : "";
            this.handleCheckChange(i);
          });
        })
        .catch(e => {
          // console.log(e);
        });
    },
    // 删除数据请求
    delPeople(arr) {
      removeDemoUser({
        ids: arr,
        isShowLoading: true,
        loadingMessage: "删除中,请稍等..."
      }).then(res => {
        this.$message({
          message: "删除成功",
          type: "success",
          // duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        this.$refs.multipleTable.tableData.length <= 1 && --this.pageNoCode;
        this.getUserList();
        this.isSelection = false;
        this.isIndeterminate = false;
      });
    },
    // 全选
    handleCheckAllChange(val) {
      this.isIndeterminate = false;
      const arr = [];
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].id);
      }
      this.idArrSelected = arr;
      if (val.length) {
        this.isSelection = true;
      } else {
        this.isSelection = false;
      }
      if (typeof val === "boolean") {
        if (val) {
          this.toggleSelection(this.tableData);
        } else {
          this.toggleSelection([]);
        }
      } else {
        this.checkAll = val.length !== 0;
      }
    },
    // 底部全选
    handleCheckAllChangeBottom() {
      this.$refs.multipleTable.toggleAllSelection();
    },
    // 单个数据选中
    handleCheckChange(val) {
      const arr = [];
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].id);
      }
      this.idArrSelected = arr;
      if (val.length) {
        this.isSelection = true;
      } else {
        this.isSelection = false;
      }
      if (val.length > 0 && val.length < this.tableData.length) {
        this.isIndeterminate = true;
      } else if (val.length === this.tableData.length) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else {
        this.checkAll = false;
        this.isIndeterminate = false;
      }
    },
    toggleSelection(rows) {
      this.$refs.multipleTable.clearSelection();
      const arr = [];
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
          arr.push(row.id);
        });
        this.idArrSelected = arr;
      }
    },
    // 排序
    changeSort(params) {
      this.sortord = params.order;
      this.sortprop = params.prop;
      this.getUserList();
    },
    // 默认显示多少条
    getLocalPageSize() {
      return getSessionItem("pageSize", this.tableList.listqueryList) || 20;
    },
    // 读取当前页缓存
    getLocalPageNo() {
      let localData = getSessionItem("pageNo", this.tableList.listqueryList);
      return (localData && localData.pageNo) || 1;
    }
  }
};
</script>
<style lang="scss">
.ccui-app-container.ccui-origin-table {
  padding-top: 20px;
  .ccui-app-top-bar {
    position: relative;
    margin-bottom: 8px;
    height: 31px;

    .title {
      position: absolute;
      left: 0;
      top: 4px;
      color: #0089ef;
      border: none;
      border-bottom: 2px solid #0089ef;
      border-radius: 0;
      font-weight: 600;
      display: inline-block;
      height: 14px;
      line-height: 14px;
      //font-weight: 400;
      font-size: 14px;
      //height: 26px;
      //line-height: 26px;
      padding: 0 0 3px;
    }

    .btn-bar {
      position: absolute;
      right: 0;
      top: -5px;
    }
  }
}
</style>
